import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

// import './index.css';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ReactToPrint from 'react-to-print';
import TablePagination from '@mui/material/TablePagination';
import { Divider, SvgIcon } from "@mui/material"
import { ReactComponent as PrintIcon } from 'assets/icons/Print.svg';
import {
    Column,
    Table as ReactTable,
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    flexRender,
} from '@tanstack/react-table';

import { Checkbox, Button as MuiButton, CircularProgress, Collapse, IconButton, Skeleton, TableSortLabel, Toolbar, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight, KeyboardArrowUp, List, Print } from '@mui/icons-material';
import { TableStyles, TableCellStyles } from './Style';
import { Button, Input, InputBase } from 'components/Form';
import { tableHooks, ToolbarColumnsButton } from '.';
import { useSelector } from 'react-redux';
import { actions } from 'store';
import { useDispatch } from 'react-redux';
import { dataGridModel } from 'keys';
import { AbilityContext } from 'components/Permissions/Can';
import { isArray, isEmpty } from 'lodash';
import { sortByFullName } from 'utils/sorting';
import { TableContext } from './TableContext';
import { initialPage } from 'keys/pagination';
import { useLocation } from 'react-router-dom';
import { Table as NestedTable } from 'components'
import { secretStorage } from 'config';
import { Space } from 'styles/GlobalStyle';
import { canAccessField } from 'config/ability';
import FilterManager from 'components/FilterManager';
import FooterPagination from './FooterPagination'

const LocalTable = (props) => {
    const {
        // filter manager
        filterSchema,
        filterValues,
        onFilterChange,
        setSelectedRowIds, selectedRowIds, hideVisibilityColumns, blurred, uniqueId = "id", CustomCollapseComponent, rowWithBg, rowClassName, rowOpen, setRowOpen, flexGrow, collapse, rowsPerPageOptions, resetRowSelection, collapseView, pageSize = 15, setPageSize, customToolbar, withTitle, hideSorting, withTabs, hideToolbar: hideTools, hidePagination, sorting, setSorting, refetch, visibilityModelKey, rowKey = "id", data, columns, loading, page, setPage, onRowSelection, bgHead, tableH } = props

    const dispatch = useDispatch()
    const location = useLocation();

    const user = secretStorage.getItem("user")
    const { is_superuser } = user || {}

    const isControlled = typeof setSelectedRowIds === 'function';
    const [innerRowSelection, setInnerRowSelection] = useState({});
    const rowSelection = isControlled ? selectedRowIds || {} : innerRowSelection;
    const setRowSelection = isControlled ? setSelectedRowIds : setInnerRowSelection;

    const [isExpanded, setIsExpanded] = useState(false);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('calories');

    const wrapperRef = useRef(null);
    const { handleSearch } = useContext(TableContext)

    const hideToolbar = hideTools

    const ability = useContext(AbilityContext)

    const { canSelectRow } = props

    const { visibilityModel } = useSelector(state => state.dataGrid)
    const { brokenDisplay } = useSelector(state => state.general)


    const tableData = React.useMemo(
        () => (loading ? Array(15).fill({}) : data?.results),
        [loading, data]
    );

    const tableColumns = React.useMemo(() => {
        if (loading) {
            return columns.map((column, index) => ({
                ...column,
                cell: <Skeleton key={index} />,
            }));
        }

        return columns?.filter(field => canAccessField(field, ability));

    }, [loading, columns, ability]);

    // פונקציית בחירה רקורסיבית משופרת - סורקת את כל העומק
    const selectAllChildren = (rowData, isSelected, selectionObject, idKey) => {
        // רשימת המפתחות האופציונליים שבהם יכולים להיות ילדים (לפי המבנה שלך)
        const childrenKeys = ['units', 'test_takers', 'classes', 'team', 'students', 'testTakers', 'results'];

        childrenKeys.forEach(key => {
            const children = rowData[key];
            if (Array.isArray(children)) {
                children.forEach(child => {
                    if (child && child[idKey]) {
                        const childId = String(child[idKey]);
                        if (isSelected) {
                            selectionObject[childId] = true;
                        } else {
                            delete selectionObject[childId];
                        }
                        // קריאה רקורסיבית כדי להגיע לרמה הכי נמוכה (למשל תלמידים בתוך כיתה בתוך שכבה)
                        selectAllChildren(child, isSelected, selectionObject, idKey);
                    }
                });
            }
        });
    };

    const onRowSelectionChange = updater => {
        const next = typeof updater === 'function' ? updater(rowSelection) : updater;
        const prevKeys = Object.keys(rowSelection);
        const nextKeys = Object.keys(next);

        const changedId = nextKeys.length > prevKeys.length
            ? nextKeys.find(id => !prevKeys.includes(id))
            : prevKeys.find(id => !nextKeys.includes(id));

        if (changedId) {
            const isSelected = !!next[changedId];
            const allRows = data?.results || (Array.isArray(data) ? data : []);
            const rowData = allRows.find(r => String(r[uniqueId]) === String(changedId));

            if (rowData) {
                const newSelection = { ...next };
                selectAllChildren(rowData, isSelected, newSelection, uniqueId);
                setRowSelection(newSelection);
                if (onRowSelection) onRowSelection(newSelection);
                return;
            }
        }

        setRowSelection(next);
        if (onRowSelection) onRowSelection(next);
    }

    const table = useReactTable({
        data: tableData,
        columns: tableColumns,
        getRowId: row => row[uniqueId],
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        autoResetRowSelection: false,
        onPaginationChange: (getPagination, y) => {
            const { pageIndex: currentIndex } = getPagination(pageIndex)
            setPage(currentIndex)
            wrapperRef.current.scrollTop = 0;
            setRowOpen?.(null)
        },
        onColumnVisibilityChange: (newModel) => {
            let val = newModel()
            dispatch(actions.updateVisibilityModel({ key: dataGridModel[visibilityModelKey], value: val }))
        },
        enableSorting: !hideSorting,
        manualPagination: true,
        rowCount: data?.count,
        debugTable: true,
        manualSortBy: true,
        onSortingChange: (sortingUpdater) => {
            setRowOpen?.(null)
            setPage(initialPage)
            let nextSort = sortingUpdater(sorting)
            const prevSort = { ...sorting[0] }

            if (
                nextSort[0]?.id === 'first_name' ||
                nextSort[0]?.id === 'last_name' ||
                (isEmpty(nextSort) && prevSort?.id === 'first_name' || prevSort?.id === 'last_name')
            ) {
                const customSort = sortByFullName(prevSort)
                if (customSort)
                    setSorting(isEmpty(customSort) ? [] : [customSort]);
                else setSorting(nextSort)

            }
            else setSorting(nextSort)
        },
        onRowSelectionChange: onRowSelectionChange,
        enableRowSelection: canSelectRow || true,
        state: {
            pagination: {
                pageSize: 15,
                pageIndex: page
            },
            rowSelection,
            sorting,
            columnVisibility: visibilityModel?.[visibilityModelKey]
        },
    });

    const { pageIndex } = table.getState().pagination;

    useEffect(() => {
        if (resetRowSelection)
            setRowSelection({})
    }, [resetRowSelection])

    useEffect(() => {
        if (!isControlled || !Array.isArray(selectedRowIds)) return;

        const mapped = selectedRowIds.reduce((acc, id) => {
            acc[id] = true;
            return acc;
        }, {});

        setSelectedRowIds(mapped);
    }, []);

    const rows = table?.getRowModel()?.rows

    return (
        <TableStyles isExpanded={isExpanded} nested={collapseView} flexGrow={flexGrow} bgHead={bgHead} tableH={tableH} className='table-wrapper' withTitle={withTitle} withTabs={withTabs} hidePagination={hidePagination} hideToolbar={hideToolbar}>
            {!hideToolbar &&
                <Toolbar sx={[{
                    pl: { sm: 2 }, pr: { xs: 1, sm: 1 },
                    flexDirection: 'column',
                    alignItems: 'flex-start', // שינוי מ-center ל-flex-start
                    justifyContent: 'flex-start', // נעילה לחלק העליון
                    minHeight: 'auto', // מונע מ-MUI לכפות גובה מינימלי
                    py: 2
                }]}>
                    <FilterManager
                        Context={TableContext}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                        wrapperRef={wrapperRef}
                        schema={filterSchema}
                        values={filterValues}
                        onChange={onFilterChange}
                        table={table}
                        handleSearch={handleSearch}
                        customToolbar={customToolbar}
                    />
                </Toolbar>}
            <TableContainer ref={wrapperRef}>
                <Table stickyHeader aria-label="collapsible table">
                    <TableHead className={collapseView || "table-head"}>
                        {isArray(table.getHeaderGroups()) && table.getHeaderGroups()?.map(headerGroup => {
                            return (
                                <TableRow key={headerGroup.id}>
                                    {onRowSelection &&
                                        <TableCell key="checkbox-header" padding="checkbox">
                                            <Checkbox
                                                color='thirdly'
                                                indeterminate={table.getIsSomeRowsSelected()}
                                                checked={table.getIsAllRowsSelected()}
                                                onChange={table.getToggleAllPageRowsSelectedHandler()}
                                            />
                                        </TableCell>}
                                    {headerGroup.headers.map(header => (
                                        <TableCell key={header.id} colSpan={header.colSpan} sx={{ width: header.column.columnDef.width, textAlign: header.column.columnDef.alignCenter && "center" }}>
                                            {header.column.getCanSort() ?
                                                <TableSortLabel
                                                    key={header.id}
                                                    active={orderBy === header.id}
                                                    direction={
                                                        header.column.getCanSort() ?
                                                            header.column.getNextSortingOrder() === 'asc' ? "asc" :
                                                                header.column.getNextSortingOrder() === 'desc' ? "desc"
                                                                    :
                                                                    order :
                                                            undefined}
                                                    onClick={header.column.getToggleSortingHandler()}
                                                    colSpan={header.colSpan}
                                                >
                                                    <div className='head-cell'>
                                                        {flexRender(
                                                            header.column.columnDef.header,
                                                            header.getContext()
                                                        )}
                                                    </div>
                                                </TableSortLabel>
                                                :
                                                flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}
                                        </TableCell>
                                    ))}
                                    {collapse?.show && <TableCell />}
                                    {collapseView && !collapse?.hideVisibilityColumns &&
                                        <TableCell>
                                            <div className='toolbar-collapse-items'>
                                                <ToolbarColumnsButton table={table} />
                                            </div>
                                        </TableCell>}
                                </TableRow>
                            )
                        })}
                    </TableHead>
                    <TableBody className={`rt-tbody`}>
                        {rows?.map((row, index) => (
                            <React.Fragment key={row.id}>
                                <TableRow
                                    className={`${rowWithBg?.(row) && `selected-row`} ${rowClassName?.(row) || ''} ${rowOpen == row.id && 'row-nested'} ${collapse?.show && 'row-with-collapse'}`}
                                    sx={{ height: 52 }}
                                    onClick={(e) => {
                                        const target = e.target;
                                        const isInteractive = target.closest('button, [role="button"], a, .MuiIconButton-root, .MuiButton-root, input, select, textarea, .MuiCheckbox-root, .MuiSwitch-root, .MuiChip-root');

                                        if (!isInteractive && collapse?.show) {
                                            const isOpening = rowOpen !== row.id;

                                            // לוגיקת הקסם: אם אנחנו פותחים שורה שהיא כבר מסומנת (Selected)
                                            // אנחנו מוודאים שכל הילדים שלה מעודכנים בסטייט לפני שהטבלה הפנימית נרנדרת
                                            if (isOpening && row.getIsSelected()) {
                                                const currentSelection = { ...rowSelection };
                                                selectAllChildren(row.original, true, currentSelection, uniqueId);
                                                setRowSelection(currentSelection);
                                                if (onRowSelection) onRowSelection(currentSelection);
                                            }

                                            collapse?.onCollapse?.(row.id, index);
                                            setRowOpen(isOpening ? row.id : null);
                                        }
                                    }}
                                >
                                    {onRowSelection &&
                                        <TableCellStyles
                                            className='checkbox'
                                            key="checkbox"
                                            padding="checkbox"
                                            collapse={rowOpen === row.id}
                                        >
                                            <Checkbox
                                                color='thirdly'
                                                checked={row.getIsSelected()}
                                                disabled={!row.getCanSelect()}
                                                onChange={row.getToggleSelectedHandler()}

                                            />
                                        </TableCellStyles>}
                                    {row.getVisibleCells().map((cell) => {
                                        let isBlurred = cell.column.columnDef.showBrokenDisplay && brokenDisplay
                                        let invalid = cell.row.original.invalid

                                        if (!is_superuser && !isBlurred)
                                            isBlurred = cell.column.columnDef.showBlurred && blurred?.(row)
                                        return (
                                            <TableCellStyles
                                                collapse={(rowOpen === row.id) || (!collapse && index === rows?.length - 1)}
                                                alignCenter={cell.column.columnDef.alignCenter}
                                                key={cell.id} size='small' component="th" scope="row">
                                                <div className={`${isBlurred && `blurred2`} ${invalid && 'invalid-cell'}`}>
                                                    {flexRender(
                                                        cell.column.columnDef.cell,
                                                        cell.getContext()
                                                    )}
                                                </div>
                                            </TableCellStyles>
                                        )
                                    })}
                                    {collapse?.show && (!isEmpty(row.original.team) || collapse?.showChollapseIcon) &&
                                        <TableCellStyles collapse={rowOpen === row.id} padding="checkbox">
                                            {
                                                CustomCollapseComponent
                                                    ?
                                                    <CustomCollapseComponent
                                                        onClick={() => {
                                                            collapse?.onCollapse?.(row.id, index)
                                                            setRowOpen(rowOpen == row.id ? null : row.id)
                                                        }}
                                                        open={rowOpen == row.id}
                                                    /> :
                                                    <IconButton
                                                        aria-label="expand row"
                                                        size="small"
                                                        onClick={() => {
                                                            collapse?.onCollapse?.(row.id, index)
                                                            setRowOpen(rowOpen == row.id ? null : row.id)
                                                        }}
                                                    >
                                                        {rowOpen == row.id ?
                                                            <KeyboardArrowUp /> :
                                                            <KeyboardArrowDown />
                                                        }
                                                    </IconButton>}
                                        </TableCellStyles>}
                                </TableRow>
                                {collapse &&
                                    // rowOpen &&
                                    <TableRow className='row-nested'>
                                        <TableCellStyles
                                            hideBorder
                                            collapse={rowOpen == row.id}
                                            style={{ paddingBottom: 0, paddingTop: 0 }}
                                            colSpan={table.getVisibleLeafColumns().length + (onRowSelection ? 1 : 0) + (collapse?.show ? 1 : 0)}
                                        >
                                            <Collapse in={row.id == rowOpen} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 4, marginTop: 1, marginBottom: 0.5 }}>
                                                    {collapse.component ? <collapse.component /> :
                                                        (collapse?.data || row.original?.team) ?
                                                            <NestedTable
                                                                {...collapse}
                                                                bgHead
                                                                hideSorting
                                                                hidePagination
                                                                hideToolbar
                                                                collapseView
                                                                blurred={collapse?.blurred}
                                                                visibilityModelKey={collapse?.visibilityModelKey}
                                                                columns={collapse?.columns}
                                                                selectedRowIds={selectedRowIds}
                                                                setSelectedRowIds={setSelectedRowIds}
                                                                onRowSelection={onRowSelection}
                                                                data={{ results: collapse?.data || row.original?.team || [] }}
                                                            />
                                                            :
                                                            <div className='collapse-loading'>
                                                                <CircularProgress color="thirdly" />
                                                            </div>
                                                    }
                                                </Box>
                                            </Collapse>
                                            {row.id == rowOpen && <Space />}

                                        </TableCellStyles>
                                    </TableRow>
                                }
                            </React.Fragment >
                        ))}
                    </TableBody >
                </Table >
            </TableContainer >
            {!hidePagination && (
                <React.Fragment>
                    <Divider sx={{ color: "#E8EEF6", width: "100%" }} />
                    <FooterPagination
                        count={data?.count || 0}
                        page={pageIndex - 1} // pageIndex של TanStack הוא לרוב מבוסס 1 במימוש שלך
                        pageSize={pageSize}
                        loading={loading}
                        onPageChange={(newPage) => {
                            setPage(newPage + 1); // עדכון ה-Prop החיצוני (מבוסס 1)
                            table.setPageIndex(newPage + 1);
                            if (wrapperRef.current) wrapperRef.current.scrollTop = 0;
                            setRowOpen?.(null);
                        }}
                        onPageSizeChange={(newSize) => {
                            setPageSize(newSize);
                            setPage(1); // חזרה לעמוד הראשון
                            if (wrapperRef.current) wrapperRef.current.scrollTop = 0;
                            setRowOpen?.(null);
                        }}
                        rowsPerPageOptions={rowsPerPageOptions}
                    />
                </React.Fragment>

            )}

        </TableStyles >
    );
}

export default LocalTable
